import { Component, OnDestroy, OnInit, Signal, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { ApplicationHeaderComponent } from '../../components/fcc-601/header/application-header/application-header.component';
import { ApplicationNavigationStepsComponent } from '../../components/fcc-601/navigation-steps/application-navigation-steps.component';
import { ApplicationNavigationBarComponent } from '../../components/fcc-601/navigation-bar/application-navigation-bar.component';
import { ApplicationFooterComponent } from '../../components/fcc-601/footer/application-footer.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { AsyncPipe } from '@angular/common';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { Subject } from 'rxjs';
import { ApplicationFormControlManagerService } from '../../../modules/application/shared/services/application-form-control-manager/application-form-control-manager.service';
import { ApplicationStateService } from '../../../modules/application/shared/services/application-state/application-state.service';
import { ReadOnlyWarningModalService } from '../../../modules/application/shared/services/read-only-warning-modal/read-only-warning-modal.service';
import { ApplicationActionsComponent } from '../../components/fcc-601/application-actions/application-actions.component';
import { ApplicationTemplateHeaderComponent } from '../../components/fcc-601/header/application-template-header/application-template-header.component';

@Component({
    selector: 'app-application-layout',
    templateUrl: './application-layout.component.html',
    styleUrls: ['./application-layout.component.scss'],
    imports: [
        RouterModule,
        SidenavComponent,
        ApplicationHeaderComponent,
        ApplicationTemplateHeaderComponent,
        ApplicationActionsComponent,
        ApplicationNavigationStepsComponent,
        ApplicationNavigationBarComponent,
        ApplicationFooterComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
    ],
})
export class ApplicationLayoutComponent implements OnInit, OnDestroy {
    private readonly loadingService = inject(LoadingService);
    private readonly applicationStateService = inject(ApplicationStateService);
    private readonly applicationFormControlManager = inject(
        ApplicationFormControlManagerService,
    );
    private readonly readOnlyWarningModalService = inject(
        ReadOnlyWarningModalService,
    );

    destroy$ = new Subject<void>();
    loading$ = this.loadingService.loading$;
    applicationState$ = this.applicationStateService.applicationState$;
    isApplicationTemplate: Signal<boolean> =
        this.applicationStateService.IsApplicationTemplate;

    ngOnInit(): void {
        if (this.applicationFormControlManager.isReadOnly()) {
            this.readOnlyWarningModalService.showForReadOnlySubject(
                'application',
            );
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
